<template>
  <!--弹框7 开始-->
  <div class="dia-info">
    <el-dialog :visible.sync="frameRemindDialog" top="35vh" :close-on-click-modal="showClo" :close-on-press-escape="showClo" :width="frameWidth" :show-close="showClo" center style="text-align: center;">
      <div style="width:100%;text-align: center;">
        <div><img src="/static/img/frame/clock.png" class="frame-small-img"></div>
        <div class="frame-text-rise">
          <div class="wordBreak">{{$t('stillInterested')}}</div>
          <div class="wordBreak">{{$t('choiceTopSelling')}}</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="booknow_button" style="float: none; width: auto;" @click="continueBooking()">Continue</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
  <!--弹框7 结束-->
  <!--引入方式-->
  <!-- <frameRemind :frameRemindDialog="frameRemindDialog"></frameRemind> -->
</template>

<script>
export default {
  name: 'frameQuotation',
  props: ['frameRemindDialog'],
  data () {
    return {
      frameWidth: '450px',
      showClo: false
    }
  },
  mounted () {
    if (document.body.clientWidth < 1001) {
      this.frameWidth = '95%'
    } else {
      this.frameWidth = '450px'
    }
  },
  methods: {
    continueBooking: function () {
      var submitInfo = {'click': 1}
      this.$emit('continueBookingFun', submitInfo)
    }
  }
}
</script>

<style scoped>
.frame-small-img{width:80px; height:80px;cursor: pointer;}
.frame-text-rise{height:50px; line-height: 22px;font-size: 16px;color: #4F4C4C;text-align: center; margin: 10px 0 10px;}
.dia-info /deep/ .el-dialog__header{padding: 0;}
</style>



// WEBPACK FOOTER //
// src/components/public/frameRemind.vue